import React from 'react';
import { Box, Typography } from '@mui/material';

interface NumeroInternoMetaProps {
  nro?: number | null;
}

/** Identificador interno del comprobante (nroFormulario), alineado a la derecha. */
const NumeroInternoMeta: React.FC<NumeroInternoMetaProps> = ({ nro }) => {
  const valor = Number(nro) > 0 ? String(nro) : '—';
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, pt: 1.5 }}>
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        Número interno{' '}
        <Box
          component="span"
          sx={{ fontWeight: 700, color: 'text.primary', fontSize: '0.875rem' }}
        >
          {valor}
        </Box>
      </Typography>
    </Box>
  );
};

export default NumeroInternoMeta;
